import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { createCollectionFailure, createCollectionSuccess, fetchCollections } from "domains/collection/actions";
import type { CreateCollectionAction } from "domains/collection/actionTypes";
import type { CollectionViewResponse } from "domains/collection/types/collectionResponses";
import { CollectionType } from "domains/collection/types/collectionType";
import { activateModal } from "domains/modal/actions";
import { router } from "router/router";

export function* createCollectionSaga({ payload, siteLanguage }: CreateCollectionAction) {
  try {
    const { co_brands, ...rest } = payload;
    const body = { ...rest, co_brand_ids: co_brands.map(({ id }) => id) };
    const response: CollectionViewResponse = yield apiFetch("collection", { body, method: "POST" });

    if (!response) throw new Error("[createCollectionSaga] Failed to create collection");

    yield router.navigate(`/collection/${response.id}`);
    yield put(createCollectionSuccess(response, siteLanguage));
    yield put(fetchCollections(CollectionType.Editable));
  } catch (error) {
    logger.error("[createCollectionSaga] Failed to create collection", error);
    yield put(createCollectionFailure());
    yield put(
      activateModal({
        id: "Error",
        params: { localisedMessageKey: "app.create.collection.modal.error_while_saving" },
      }),
    );
  }
}
